import { all } from 'redux-saga/effects';
import marketsSagas from './marketsSagas';
import errorsSagas from './errorsSagas';
import slipSagas from './slipSagas';
import addToBetslipSagas from './addToBetslipSagas';
const rootSaga = function* rootSaga() {
    yield all([
        ...marketsSagas,
        ...errorsSagas,
        ...slipSagas,
        ...addToBetslipSagas,
    ]);
};
export default rootSaga;
